export default __webpack_public_path__ + "static/media/Kwenchiconsblack.c5509651.svg";